// extracted by mini-css-extract-plugin
export default {"loginMain":"Login_loginMain__rsyB4"};